import { render, staticRenderFns } from "./CodeBlockView.vue?vue&type=template&id=54c047fa&scoped=true&"
import script from "./CodeBlockView.vue?vue&type=script&lang=js&"
export * from "./CodeBlockView.vue?vue&type=script&lang=js&"
import style0 from "./CodeBlockView.vue?vue&type=style&index=0&id=54c047fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c047fa",
  null
  
)

export default component.exports